import { PurchaseDialog } from "@features/dashboard/components/PurchaseDialog";
import { useMemo } from "react";
import { useDialog } from "../DialogContext";
import type {
	DialogSpec,
	ShowDialogBehavior,
	ShowPurchaseOptions,
} from "../types";

export const purchaseDialog: DialogSpec<"purchase"> = {
	render: ({ options, onClose }) => {
		const { onNavigateBack } = options;
		return (
			<PurchaseDialog
				visible
				handleClose={onClose}
				productType={options.productType}
				fromPracticeTestPage={options.fromPracticeTestPage}
				fromHomePage={options.fromHomePage}
				explicitProductId={options.explicitProductId}
				explicitProductNumericId={options.explicitProductNumericId}
				handleBack={
					onNavigateBack
						? () => {
								onClose();
								onNavigateBack();
							}
						: undefined
				}
			/>
		);
	},
	getMobileRoute: (options) => ({
		pathname: "/purchase",
		params: {
			productType: options.productType,
			...(options.explicitProductId && {
				explicitProductId: options.explicitProductId,
			}),
			...(options.explicitProductNumericId !== undefined && {
				explicitProductNumericId: String(options.explicitProductNumericId),
			}),
			...options.routeParams,
		},
	}),
};

export const usePurchaseDialog = () => {
	const { showDialog, hideDialog } = useDialog();
	return useMemo(
		() => ({
			showPurchase: (
				options: ShowPurchaseOptions,
				behavior?: ShowDialogBehavior,
			) => showDialog("purchase", options, behavior),
			hidePurchase: () => hideDialog("purchase"),
		}),
		[showDialog, hideDialog],
	);
};
